/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Close: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="close" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M993.2675 1046.7325C1008.015 1061.48 1031.9424999999999 1061.48 1046.69 1046.7325S1061.4375 1008.0574999999998 1046.69 993.31L733.4224999999999 680.0425L1046.69 366.775C1061.4375 352.0274999999999 1061.4375 328.0999999999999 1046.69 313.3525S1008.015 298.6049999999998 993.2675 313.3525L679.9999999999999 626.62L366.7324999999999 313.3525C351.9849999999999 298.6049999999998 328.0574999999999 298.6049999999998 313.31 313.3525S298.5625 352.0274999999999 313.31 366.775L626.5775 680.0425L313.31 993.31C298.5625 1008.0574999999998 298.5625 1031.9850000000001 313.31 1046.7325S351.9849999999999 1061.48 366.7324999999999 1046.7325L679.9999999999999 733.4649999999999L993.2675 1046.7325z" : "M794.6139999999999 837.386C806.412 849.184 825.554 849.184 837.352 837.386S849.1500000000001 806.4459999999999 837.352 794.648L586.7379999999999 544.034L837.352 293.42C849.1500000000001 281.622 849.1500000000001 262.48 837.352 250.6819999999999S806.412 238.8839999999999 794.6139999999999 250.6819999999999L543.9999999999999 501.296L293.3859999999999 250.6819999999999C281.588 238.8839999999999 262.4459999999999 238.8839999999999 250.648 250.6819999999999S238.85 281.622 250.648 293.42L501.2619999999999 544.034L250.648 794.648C238.85 806.4459999999999 238.85 825.588 250.648 837.386S281.588 849.184 293.3859999999999 837.386L543.9999999999999 586.7719999999999L794.6139999999999 837.386z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Close.displayName = `Blueprint5.Icon.Close`;
export default Close;
